// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HYp50","left":"styles_left__2iRZn","desktopActions":"styles_desktopActions__mVMNj","title":"styles_title__v_ZDG"};